import Header from "../tpl/header";
import Pdf from "../tpl/pdf";
import Footer from "../tpl/footer";
import Draw from "../tpl/draw";
import DatePicker from "../tpl/datepicker";
import Mask from "../tpl/mask";
import Loading from "../tpl/loading";
import _Float from "../plugins/float";
import { dataURLToFile, getPicFromCustomText } from "../utils/dataURLToFile";
import compoundPdf from "../request/pdf";
import realNameVerification from "../request/realNameVerification";
import signVerification from "../request/signVerification";
import getSigningCompany from "../request/getSigningCompany";
import renderPdf from "../utils/pdfRender";
import {
  getFromStorage,
  removeStorage,
  pushToStorage,
  addToStorage,
} from "../utils/localStorage";
import eb from "../utils/eventbus";
import "jquery-confirm/css/jquery-confirm.css";
import "jquery-confirm/js/jquery-confirm.js";
import swal from "sweetalert";
import "sweetalert/dist/sweetalert.min.js";
const container = $("#container");
const header = Header();
const pdf = Pdf();
const footer = Footer();
const draw = Draw();
const datePicker = DatePicker();
const mask = Mask();
const loading = Loading();
var signArr;
var floatArr = [];
var specifiedPos = { x: 100, y: 100 }; // 指定签名摆放的位置,默认为x:100 y:100
var selectSignatureHandler = false;
var filedName = null;
var phone = null;
var userId = null;
var userRole = null;
var authorizeCode = null;
var cid = null;
// var backUrl = 'https://h5.xinfushenghuo.cn/#/enterpriseSuccessful'
var backUrl = "https://h5.xinfushenghuo.cn/#/realNameKnow";

// 继承Float类,添加删除回调
class Float extends _Float {
  signDeleteHandler(id) {
    if (floatArr.length < 0) {
      selectSignatureHandler = false;
    }
    floatArr = floatArr.filter((item) => item.id !== id);
  }
}
// event handler
// 签名列表draw打开/关闭
const drawToggleHandler = (flag) => {
  draw.toggle(flag);
  mask.toggle(flag);
};

// 添加签名
const addSignatureHandler = (e) => {
  const tar = $(e.currentTarget);
  const signItem = signArr.find((item) => item.id === tar.attr("data-id"));
  if (!signItem) {
    selectSignatureHandler = false;
    return;
  }
  selectSignatureHandler = true;
  floatArr.push(new Float({ ...signItem, ...specifiedPos }));
  drawToggleHandler();
};
// 显示签名页面(手写)
const showSignPage = () => {
  // eslint-disable-next-line
  window && window.history.pushState({}, null, "/sign");
  eb.emit("showSignPage");
};

// 弹出时间选择器
const showDatePicker = () => {
  mask.toggle(true);
  datePicker.show();
};
const closedPage = () => {
  window.location.href = backUrl;
};

// 隐藏时间选择器
const datepickerCloseHandler = () => {
  mask.toggle(false);
  datePicker.hide();
};
// 添加时间签名
const addTimeHandler = (e) => {
  const tar = $(e.currentTarget);
  floatArr.push(
    new Float({
      id: `${Math.random()}`.slice(2, 5) + `${Date.now()}`.slice(-5, -1),
      img: getPicFromCustomText(tar.text()),
      canScale: false,
    })
  );
  datepickerCloseHandler();
};
//签署验证

const verificationSgin = async () => {
  if (!selectSignatureHandler) {
    $.alert({
      title: "温馨提示",
      content: "请去选择一个签名",
      icon: "fa fa-info-circle",
      type: "blue",
      buttons: {
        ok: {
          text: "确定",
          btnClass: "btn-blue",
        },
      },
    });
    return;
  }
  confirmHandler();

  // swal({
  //   text: '本次签名需要使用手机验证码',
  //   button: {
  //     text: "发送验证码",
  //     closeModal: false,
  //   }
  // })
  //   .then(name => {
  //     //if (!name) throw null;
  //     return fetch(`http://192.168.0.161:9087/v1/contractCenter/sendCode?userId=${userId}`);
  //   })
  //   .then(results => {
  //     // console.log(results);
  //     return results.json();
  //   })
  //   .then(json => {
  //     if (json.code == 200) {
  //       swal({
  //         text: '请输入验证码',
  //         content: "input",
  //         button: {
  //           text: "验证并提交",
  //           closeModal: true,
  //         }
  //       }).then(name => {
  //         if (!name) throw null;
  //         authorizeCode = name;
  //         return fetch(`http://192.168.0.161:9087/v1/contractCenter/verificationCode?userId=${userId}&code=${name}`);
  //       }).then(results => { return results.json(); }).then(json => {
  //         if (json.code != 200) {
  //           swal({
  //             title: json.message,
  //             text: json.message,
  //             icon: "warning",
  //           });
  //         } else {
  //           confirmHandler();
  //         }
  //         return;
  //       })
  //     } else {
  //       swal({
  //         title: json.message,
  //         text: json.message,
  //         icon: "warning",
  //       });
  //       return;
  //     }
  //   });
};

// 完成签署
const confirmHandler = async () => {
  //   //自动处理添加公章处理
  // let companyInfo = floatArr[0];
  // let getSigningCompanyInfo = await getSigningCompany({ id: cid });
  // let CompanyImg = companyInfo.img;
  // console.log(getSigningCompanyInfo);
  // console.log(`====`);
  // if (getSigningCompanyInfo.code == 200) {
  //   CompanyImg = getSigningCompanyInfo.data.info.img;
  // }

  // floatArr.push({
  //   canScale: true,
  //   dispHeight: companyInfo.dispHeight,
  //   dispWidth: companyInfo.dispWidth,
  //   height: companyInfo.height,
  //   id: cid,
  //   img: CompanyImg,
  //   page: companyInfo.page,
  //   selectSignatureHandler: companyInfo.companyInfo,
  //   target: companyInfo.target,
  //   width: companyInfo.width,
  //   x: companyInfo.x + 300,
  //   y: companyInfo.y,
  // });
  // let test = $(".confirm-btn").text();
  $(".confirm-btn").attr("disabled", "disabled");
  var count = 10;
  var countdown = setInterval(CountDown, 1000);
  function CountDown() {
    $(".confirm-btn").attr("disabled", true);
    $(".confirm-btn").text("请等待" + count + "S后再提交");
    if (count == 0) {
      $(".confirm-btn").removeAttr("disabled");
      clearInterval(countdown);
      $(".confirm-btn").text("确认签署");
    }
    count--;
  }
  const getFile = () => {
    const len = floatArr.length;
    let idx = 0;
    return new Promise((resolve) => {
      floatArr.forEach(async (item) => {
        // eslint-disable-next-line
        item.file = await dataURLToFile(item.img);
        // eslint-disable-next-line
        idx++;
        if (idx === len) {
          resolve();
        }
      });
    });
  };
  await getFile();

  const formdata = new FormData();
  const configArr = [];
  const signatureImage = [];
  for (let i = 0, len = floatArr.length; i < len; i++) {
    formdata.append("imgs", floatArr[i].file);
    configArr.push({
      x: floatArr[i].x || 171.92211055276383,
      y: floatArr[i].y || 683.2035175879397,
      width: floatArr[i].width || 80,
      height: floatArr[i].height || 80,
      page: floatArr[i].page,
    });
    signatureImage.push({ id: floatArr[i].id, img: floatArr[i].img });
  }
  console.log(configArr,'-------------------');
  formdata.append("config", JSON.stringify(configArr));
  formdata.append("filedName", filedName); //合同中心编号
  formdata.append("userId", userId);
  formdata.append("authorizeCode", authorizeCode);
  formdata.append("signatureImage", JSON.stringify(signatureImage));
  //formdata.append('signArr', JSON.stringify(signArr));
  const res = await compoundPdf(formdata);
  // console.log(res, "res授权成功");
  swal({
    icon: "success",
    text: "用户信用授权成功",
    buttons: false,
    timer: 1000,
  }).then(() => {
    window.location.href = backUrl;
  });
  $(".J_footer").hide();
  $(".pdf-preview-wrap").css("padding-bottom", 0);
  // backUrl = 'https://h5.xinfushenghuo.cn/#/paymentActivation'
  backUrl = "https://h5.xinfushenghuo.cn/#/realNameKnow";

  renderPdf("#preview", `/api/pdf/getpdf?filename=${res.filename}`).on(
    "complete",
    () => {}
  );
};

// pdf点击事件: 记录点击位置 => 打开签名列表draw
const handlePdfPageClick = (e) => {
  const { clientX, clientY } = e;
  specifiedPos = {
    x: clientX - parseInt($(".pdfViewer").css("padding-left"), 10),
    y:
      clientY +
      $(".viewerContainer")[0].scrollTop -
      $(".header").height() -
      parseInt($(".pdfViewer").css("padding-top"), 10),
  };
  drawToggleHandler(true);
};
// 遮罩层点击
const maskClickHandler = () => {
  drawToggleHandler();
  datepickerCloseHandler();
};
const render = () =>
  new Promise((resolve) => {
    let domStr = "";
    domStr += header.renderHeader();
    domStr += pdf.render();
    domStr += footer.render();
    domStr += draw.render(signArr);
    domStr += datePicker.render();
    domStr += mask.render();
    domStr += loading.render();
    container.append(domStr);
    resolve();
  });
const bindEvent = () => {
  // 首页footer点击事件
  $(".J_footer")
    .on("click", ".add-btn", drawToggleHandler.bind(null, true)) // footer按钮点击事件
    .on("click", ".confirm-btn", verificationSgin)
    .on("click", ".sign-btn", showSignPage)
    .on("click", ".date-btn", showDatePicker);

  // draw事件代理
  $(".J_draw")
    .on("click", ".close-btn", drawToggleHandler.bind(this, false)) // draw关闭按钮点击事件
    .on("click", ".exist-signature", addSignatureHandler)
    .on("click", ".add-signature", drawToggleHandler, showSignPage);

  // mask遮罩层事件
  $(".J_mask").on("click", maskClickHandler);

  // $('#preview').on('del-sign', signDeleteHandler);

  // 时间选择器点击事件
  $(".J_datepicker-wrap")
    .on("click", ".cancel", datepickerCloseHandler)
    .on("click", ".candidate-item", addTimeHandler);

  // pdf点击事件
  $(".pdfViewer").on("click", handlePdfPageClick);
  //返回关闭
  eb.on("freshDraw", () => {
    signArr = getFromStorage("signArr");
    draw.reFresh(signArr);
  });
  $("#closedPage").on("click", closedPage);
};
async function init() {
  removeStorage("signArr"); //先清空所有保存后的签名数据
  //removeStorage('userRole')
  var url = window.location.href;
  console.log(url);

  let urlStr = url.split("?")[1];
  // 创建空对象存储参数
  var paramObj = {};
  // 再通过 & 将每一个参数单独分割出来
  let paramsArr = urlStr.split("&");
  // console.log(paramsArr,'paramsArrparamsArr')
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    // 再通过 = 将每一个参数分割为 key:value 的形式
    let arr = paramsArr[i].split("=");
    paramObj[arr[0]] = arr[1];
  }
  // console.log(paramObj,'paramObjparamObj')
  filedName = paramObj["name"].split('.')[0];
  // console.log(paramObj["name"].split('.')[0],'filedNamefiledName')
  // userRole = paramObj['userRole'];  //角色判断
  cid = paramObj["cid"];
  userId = paramObj["userId"];
  //console.log(phone);
  addToStorage("userRole", userRole);
  // let realNameVerificationRet = await realNameVerification({ userId: userId });
  // let signVerificationRet = await signVerification({
  //   contractNumber: filedName,
  //   userId: userId,
  // });
  //console.log(realNameVerificationRet);
  // if (realNameVerificationRet.code != 200) {
  //   window.location.href = "https://www.example.com";
  //   return;
  // }

  // console.log(signVerificationRet);

  // console.log(realNameVerificationRet);
  // if (signVerificationRet.code != 200) {
  //   swal({
  //     title: "温馨提示",
  //     text: signVerificationRet.message,
  //     icon: "warning",
  //     //button: "Aww yiss!",
  //   });
  //   return;
  // }

  //window.location.href = 'https://www.example.com';
  //goto  = paramObj['goto'];

  //userRole = getFromStorage('signArr');
  //公司角色
  // if(userRole == 2) {
  //   //const reqData = JSON.stringify({"phoneNum":phone})
  //   const ret = await initChapter({"phoneNum":phone, type:userRole });
  //   const obj  = eval(ret['data']['data']);
  //   for(let i=0 ; i<obj.length ; i++ ){
  //     let arr = getFromStorage('signArr');
  //     //console.log(`进入${i}`);
  //     arr ? pushToStorage('signArr', obj[i]) : addToStorage('signArr', [obj[i]]);
  //   }
  // }

  return new Promise((resolve) => {
    // 保存所签名的文件，
    signArr = getFromStorage("signArr");
    render().then(() => {
      renderPdf(
        "#preview",
        `/api/pdf/default?filedUrl=${paramObj["filedUrl"]}&name=${filedName}`
      ).on("complete", (data) => {
        console.log(data);
        bindEvent();
        resolve();
      });
    });
  });
}

// (function(){
//   window.alert = function(name){
//   var iframe = document.createElement("IFRAME");
//   iframe.style.display="none";
//   iframe.setAttribute("src", 'data:text/plain');
//   document.documentElement.appendChild(iframe);
//   window.frames[0].window.alert(name);
//   iframe.parentNode.removeChild(iframe);
//   }
// })();

export default init;
